module.exports = __webpack_public_path__ + "media/images/talent/button-appstore-cdb0610ae2beb302197e3513c2f28e1d.svg";